import { Link } from 'gatsby';
import styled from 'styled-components';
import {
    ContainerColumnStart,
    ContainerColumnStartWithoutWidth,
    LinkButton,
    SectionHeadline,
    SectionTitle,
    SectionTitleLink,
} from '../../styles/Common';
import { deviceMax } from '../../styles/MediaQuery';
import {
    blue,
    containerWidth,
    darkGreen,
    greyBorder,
    greyLight,
    lightGrayishBlue,
    paragraphMargin,
    white,
} from '../../styles/Variables';

const cardsContainerGap = '1.25rem';

export const Container = styled(ContainerColumnStart)`
    max-width: ${containerWidth};
    margin: 1rem auto;
    width: 90%;
`;

export const Title = styled(SectionTitle)`
    font-size: 2.375rem;
    margin-top: ${paragraphMargin};
    line-height: 2.75rem;
`;

export const Description = styled.p`
    font-size: 1rem;
    font-family: Arial, Helvetica, sans-serif;
    margin: 0;
    line-height: 1.5rem;
    margin-top: ${paragraphMargin};
`;

export const CardsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: ${paragraphMargin};
`;

interface CardType {
    readonly isGreyBackground?: boolean;
    readonly isNotContactCard?: boolean;
    readonly isActive?: boolean;
}

export const Card = styled(ContainerColumnStartWithoutWidth)<CardType>`
    ${(props) => props.isGreyBackground && `background-color: ${greyLight};`}
    width: 280px;
    margin-right: ${cardsContainerGap};
    margin-bottom: ${cardsContainerGap};
    padding: 0;
    position: relative;
    min-height: 490px;

    &:nth-child(3n) {
        margin-right: 0;
    }

    @media ${deviceMax.tabletL} {
        width: calc(50% - ${cardsContainerGap} / 2);
        min-height: 0;
        height: auto;

        &:nth-child(3n) {
            margin-right: auto;
        }

        &:nth-child(2n) {
            margin-right: 0;
        }
    }

    @media ${deviceMax.mobileXl} {
        width: 100%;
        margin-right: 0;
    }
`;

export const CardTitleContainer = styled.div<CardType>`
    display: flex;
    align-items: center;
    background-color: ${greyLight};
    padding: 1.25rem 0;
    width: 100%;
    min-height: 30px;

    ${(props) =>
        props.isNotContactCard &&
        `
        @media ${deviceMax.mobileLm} {
            text-transform: capitalize;
            background-color: ${white};
            padding: 0 0 1.25rem 0;
            align-items: center;
        }
    `}
`;

export const CardTitle = styled(SectionHeadline)<CardType>`
    padding: 0 1.25rem;
    margin: 0;
    font-size: 0.9375rem;

    ${(props) =>
        props.isNotContactCard &&
        `
        @media ${deviceMax.mobileLm} {
            text-transform: capitalize;
            font-size: 1.5rem;
            color: ${blue};
            padding: 0;
            align-self: flex-end;
        }
    `}
`;

export const CardImg = styled.img`
    width: 100%;
    height: 145px;
    margin: 0;
    padding: 0;
    object-fit: cover;

    @media ${deviceMax.mobileXl} {
        max-height: 300px;
        height: auto;
    }

    @media ${deviceMax.mobileLm} {
        display: none;
    }
`;

export const CardTextContent = styled.div<CardType>`
    border: 1px solid ${greyBorder};
    border-top: none;
    height: calc(100% - 74px - 145px);
    padding: 20px;
    transition: 0.4s;
    width: calc(100% - 42px);

    * {
        margin: 0;
    }

    @media ${deviceMax.mobileLm} {
        border: none;
        padding: 0 20px;
        height: ${(props) => (props.isActive ? '100%' : '0')};
        overflow: hidden;
    }
`;

export const CardDescription = styled.div`
    margin-bottom: 0.875rem;

    * {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
`;

export const CardLinks = styled(ContainerColumnStartWithoutWidth)``;

export const IndustryLink = styled(Link)`
    font-size: 0.875rem;
    color: ${darkGreen};
    text-decoration: none;
`;

export const ContactCardTitle = styled(SectionTitleLink)`
    padding: 1.25rem 1.25rem 0 1.25rem;
    margin-bottom: 1.25rem;
`;

export const ContactCardDescription = styled(CardDescription)`
    padding: 0 1.25rem 2.5rem 1.25rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.875rem;
`;

export const ContactButtonLink = styled(LinkButton)`
    margin: 1.25rem;
    line-height: 1.25rem;
    padding: 0.875rem 2rem;
    font-size: 0.875rem;
    font-family: Arial, Helvetica, sans-serif;
    margin-top: auto;

    &:hover {
        background: none;
        background-color: ${lightGrayishBlue};
    }
`;
